var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThinkShrink(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "89px",
    height: "89px",
    viewBox: "0 0 89 89",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ThinkShrink") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0.2447 0.1584 11.035 0.1584 11.035 11 0.2447 11"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "0 0.4387 47.8646 0.4387 47.8646 48.3027 0 48.3027"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ThinkShrink",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(19.000000, 19.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(39.000000, 39.561500)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3027,6.7324 L3.7287,0.1584 C2.6937,1.4704 1.5277,2.6744 0.2447,3.7454 L6.7677,10.2674 C7.2557,10.7554 7.8957,11.0004 8.5347,11.0004 C9.1747,11.0004 9.8147,10.7554 10.3027,10.2674 C11.2797,9.2914 11.2797,7.7094 10.3027,6.7324",
    id: "Fill-1",
    fill: "#FCBC00",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(0.000000, 0.561500)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9326,43.3027 C13.4936,43.3027 4.9996,34.8097 4.9996,24.3697 C4.9996,13.9317 13.4936,5.4387 23.9326,5.4387 C34.3706,5.4387 42.8646,13.9317 42.8646,24.3697 C42.8646,34.8097 34.3706,43.3027 23.9326,43.3027 M23.9326,0.4387 C10.7366,0.4387 -0.0004,11.1737 -0.0004,24.3697 C-0.0004,37.5667 10.7366,48.3027 23.9326,48.3027 C29.7526,48.3027 35.0926,46.2117 39.2456,42.7447 C40.5276,41.6747 41.6936,40.4707 42.7286,39.1577 C45.9406,35.0837 47.8646,29.9487 47.8646,24.3697 C47.8646,11.1737 37.1286,0.4387 23.9326,0.4387",
    id: "Fill-4",
    fill: "#FFFFFF",
    mask: "url(#mask-4)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThinkShrink);
export default __webpack_public_path__ + "static/media/think-shrink.58073c8149e4be9b8e4b12f3f116685c.svg";
export { ForwardRef as ReactComponent };